import { Controller } from "@hotwired/stimulus"

// On the item <select> of one line row. Fills blank (or previously prefilled) inputs of that row.
export default class extends Controller {
  pick() {
    const opt = this.element.selectedOptions[0]
    if (!opt || !opt.value) return
    const row = this.element.closest("[data-line-items-target='row']")
    const fill = (suffix, value) => {
      const input = row.querySelector(`[name$='[${suffix}]']`)
      if (!input || value === undefined) return
      if (input.value === "" || input.dataset.prefilled === input.value) {
        input.value = value
        input.dataset.prefilled = value
      }
    }
    fill("item", opt.dataset.name)
    fill("description", opt.dataset.description)
    fill("unit", opt.dataset.unit)
    fill("unit_price", opt.dataset.price)
    row.querySelector("[name$='[unit_price]']")?.dispatchEvent(new Event("input", { bubbles: true }))
  }
}
